import React from "react";
import {
  AddPropertyIcon,
  AddTenantIcon,
  TrackPaymentsIcon,
  FollowUpIcon,
} from "./icons/SvgIcons";

const steps = [
  { icon: AddPropertyIcon, n: "1", title: "Add your property", text: "Enter your building name and address. Add as many properties as you manage." },
  { icon: AddTenantIcon, n: "2", title: "Add tenants", text: "Fill in tenant details, assign houses, set rent amounts and due dates." },
  { icon: TrackPaymentsIcon, n: "3", title: "Track payments", text: "Record full, partial, or multi month payments. Paysafi tracks balances automatically." },
  { icon: FollowUpIcon, n: "4", title: "Follow up automatically", text: "Send SMS or AI call reminders to overdue tenants with one click." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="border-b border-gray-100 bg-gray-50 py-16 dark:border-gray-800 dark:bg-gray-900 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-indigo-600 dark:text-indigo-400">
            How it works
          </span>
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            Get started in minutes
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400">
            Four simple steps to take control of your rent collection.
          </p>
        </div>
        <div className="relative mt-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div key={s.n} className="relative text-center">
              <div className="flex justify-center">
                <s.icon size={64} bg="#EEF2FF" />
              </div>
              <span className="mt-4 inline-flex h-7 w-7 items-center justify-center rounded-full bg-indigo-600 text-xs font-bold text-white">
                {s.n}
              </span>
              <h3 className="mt-3 text-base font-semibold text-gray-900 dark:text-white">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-600 dark:text-gray-400">{s.text}</p>
              {i < steps.length - 1 && (
                <svg
                  className="absolute right-0 top-8 hidden h-5 w-8 text-gray-300 dark:text-gray-600 lg:block"
                  viewBox="0 0 32 20"
                  fill="none"
                  style={{ transform: "translateX(100%)" }}
                >
                  <path d="M0 10h24m0 0-6-6m6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
